function insight(backendAxiosInstance) {
  async function getMoreLikeThisVod(contentId, max) {
    return backendAxiosInstance.get("/contents/v3/insight/morelikethis/vod", {
      params: {
        contentId,
        max
      }
    });
  }
  async function getMoreLikeThisEpg(contentId, max) {
    return backendAxiosInstance.get("/contents/v3/insight/morelikethis/epg", {
      params: {
        contentId,
        max
      }
    });
  }
  return {
    getMoreLikeThisVod,
    getMoreLikeThisEpg
  };
}

export { insight as default };
//# sourceMappingURL=insight.js.map
